import { render, staticRenderFns } from "./CGAModal.vue?vue&type=template&id=0fe14a14&scoped=true&"
import script from "./CGAModal.vue?vue&type=script&lang=js&"
export * from "./CGAModal.vue?vue&type=script&lang=js&"
import style0 from "./CGAModal.vue?vue&type=style&index=0&id=0fe14a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe14a14",
  null
  
)

export default component.exports